import { render, staticRenderFns } from "./afterSalesOrder.vue?vue&type=template&id=2ecc1209&scoped=true"
import script from "./afterSalesOrder.vue?vue&type=script&lang=js"
export * from "./afterSalesOrder.vue?vue&type=script&lang=js"
import style0 from "./afterSalesOrder.vue?vue&type=style&index=0&id=2ecc1209&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecc1209",
  null
  
)

export default component.exports